const selected = { color: [], grade: [], fabric: [], series: [] };
let itemCount = 0;

const norm = v => String(v ?? '').trim().toLowerCase();

class americanSwatch {
  constructor() {
    const groups = {
      color:  document.querySelectorAll('[data_color]'),
      grade:  document.querySelectorAll('[data_grade]'),
      fabric: document.querySelectorAll('[data_fabric]'),
      series: document.querySelectorAll('[data_leather]') // Series inputs
    };

    itemCount = document.querySelectorAll('[data-swatch-item]').length;

    Object.entries(groups).forEach(([key, boxes]) => {
      boxes.forEach(box => {
        box.addEventListener('change', () => {
          selected[key] = [...boxes].filter(b => b.checked).map(b => norm(b.value));
          this._loadSwatchGrid();
        });
      });
    });
  }

  _loadSwatchGrid() {
    const emptySearch = document.querySelector('[empty-search]');
    const items = document.querySelectorAll('[data-swatch-item]');
    const anyFilter = Object.values(selected).some(arr => arr.length);

    if (!anyFilter) {
      items.forEach(i => i.classList.remove('d-none'));
      if (emptySearch) emptySearch.classList.add('d-none');
      return;
    }

    let hiddenCount = 0;

    items.forEach(swatchItem => {
      const script = swatchItem.querySelector('[data-swatch-details]');
      let visible = false;

      try {
        const data = JSON.parse(script.textContent);
        visible = data.some(d => {
          const match = (sel, val) => sel.length === 0 || sel.includes(norm(val));
          return (
            match(selected.color,  d.color) &&
            match(selected.grade,  d.grade) &&
            match(selected.fabric, d.fabric_type) &&
            match(selected.series, d.series)
          );
        });
      } catch (e) {
        console.error('Bad swatch JSON', e, script && script.textContent);
      }

      swatchItem.classList.toggle('d-none', !visible);
      if (!visible) hiddenCount++;
    });

    if (emptySearch) emptySearch.classList.toggle('d-none', hiddenCount !== itemCount);
  }
}

new americanSwatch();